var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChange),expression:"visibilityChange"}],tag:"div",staticClass:"gradient",class:_vm.classes,style:(_vm.initialStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }